import React from "react";
import {setDigitalData} from "@/services/setDigitalData";
import { Link } from "react-router-dom";

const DandBHoovers = ({ props }) => {
  const { heading, content, buttonLabel, buttonRedirectionLink } = props;
  return (
    <>
      <div className="component-wrapper bgcolor-light-blue">
        <div className="container">
          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6 col-md-offset-3">
              <div className="colPar0 parsys">
                <div className="content_card section">
                  <div className="component-wrapper free-trial text-center">
                    <h3>{heading}</h3>
                    <div className="row pad-lr-0">
                      <div className="col-md-12 img"></div>
                      <div className="col-md-12 text">
                        <div className="meta">
                          <div className="contenttype_area"></div>
                          <span className="manual">{content}</span>
                          <Link to={buttonRedirectionLink} onClick={() => {setDigitalData({gcpPageName: 'getAFreeTrial'})}}>
                            <div>
                              <span className="cta-left button-free-trial">
                                {buttonLabel}
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clear"></div>
      </div>
    </>
  );
};

export default DandBHoovers;
